// api/TV
import request from '@utils/request'

const url = 'api/TV/'

/**
 *
 * 修改公司logo
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateLogo (data) {
  return request({
    url: url + 'UpdateLogo',
    method: 'post',
    data
  })
}
/**
 *
 * 获取电表电站信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function MeterStationInfo (data) {
  return request({
    url: url + 'MeterStationInfo',
    method: 'post',
    data
  })
}

/**
 *
 * 获取发电能量平衡图数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMeterEnergyBalanceChartData (data) {
  return request({
    url: url + 'GetMeterEnergyBalanceChartData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取用电能量平衡图数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMeterEnergyBalanceChartData2 (data) {
  return request({
    url: url + 'GetMeterEnergyBalanceChartData2',
    method: 'post',
    data
  })
}

/**
 *
 * 获取用户公司logo和名称
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetCompanyInfo (data) {
  return request({
    url: url + 'GetCompanyInfo',
    method: 'post',
    data
  })
}
/**
 *
 * 获取电表电站的概览信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMeterStationOverviewData (data) {
  return request({
    url: url + 'GetMeterStationOverviewData',
    method: 'post',
    data
  })
}

/**
 *
 * 获取用户大屏的Url
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetUrl (data) {
  return request({
    url: url + 'GetUrl',
    method: 'post',
    data
  })
}

/**
 *
 * 获取当前登录用户的logo
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetLoginUserLogo (data) {
  return request({
    url: url + 'GetLoginUserLogo',
    method: 'post',
    data
  })
}

/**
 *
 * 查询气象天气
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetWeatherReal (data) {
  return request({
    url: url + 'GetWeatherReal',
    method: 'post',
    data
  })
}

/**
 *
 * 查询设备绑定
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryBindGateway (data) {
  return request({
    url: url + 'QueryBindGateway',
    method: 'post',
    data
  })
}

/**
 *
 * 天气设备绑定
 * @export
 * @param {*} data
 * @return {*}
 */
export function BindWeatherDevice (data) {
  return request({
    url: url + 'BindWeatherDevice',
    method: 'post',
    data
  })
}

/**
 *
 * 设备解绑
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteBind (data) {
  return request({
    url: url + 'DeleteBind',
    method: 'post',
    data
  })
}
/**
 *
 * 获取光伏和用电日月年柱状图数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetEnergyOverviewData (data) {
  return request({
    url: url + 'GetEnergyOverviewData',
    method: 'post',
    data
  })
}

/**
 *
 *鼎威大屏图表接口（V1）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetEnergyChartData (data) {
  return request({
    url: url + 'GetEnergyChartData',
    method: 'post',
    data
  })
}

/**
 *
 *电表大屏图表接口（V1）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetUniversalTVOverviewData (data, needMagnumToken = false) {
  const result = needMagnumToken
    ? request({
      url: url + 'GetUniversalTVOverviewData',
      method: 'post',
      data,
      headers: {
        "magnum-token": true,
      },
    })
    : request({
      url: url + 'GetUniversalTVOverviewData',
      method: 'post',
      data,
    })
  return result
}

